module.exports = function getResource(label, vars = []) {
    let resources = {
        title: 'Recently Viewed'
    };

    return resources[label];
};
